import type { FC } from 'react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { IPublicProps as IProgressBarProps } from '@alfa-bank/site-progress-bar-v2/src/models';
import { publish } from '@alfa-bank/site-event-bus';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { selectDraftData, declineRestoreDraft } from '@alfa-bank/site-dc-form-api/store';

import { draftStepAnalytics as analytics } from '../../analytics';

import type { TDraft } from './models';
export const Draft: FC<TDraft> = ({
    DraftOffer,
    className,
    draftDeclineEventName,
    draftScreen,
    progressBar,
    queryParam,
    timerText,
}) => {
    const progressBarConfig: IProgressBarProps = {
        hatchValue: 100,
        header: 'steps',
        line: 'hatching',
        steps: 'Осталось только выбрать, как получить карту',
        value: 80,
    };

    const dispatch = useDispatch();
    const { cookieData } = useSelector(selectDraftData);
    const { draftId, firstName, middleName } = cookieData || {};

    const isMiddleNameExist = middleName !== '-';

    return (
        <div className={className} id="draft">
            <DraftOffer
                queryParam={queryParam}
                {...draftScreen}
                draftId={draftId}
                onClickAgree={() => {
                    sendEvent(analytics.agree);
                }}
                onClickDisagree={() => {
                    dispatch(declineRestoreDraft());
                    if (draftDeclineEventName) {
                        publish(draftDeclineEventName, true);
                    }

                    sendEvent(analytics.disagree);
                }}
                progressBar={{
                    ...progressBarConfig,
                    ...progressBar,
                }}
                timerText={timerText}
                userName={`${firstName} ${isMiddleNameExist ? middleName : ''}`}
            />
        </div>
    );
};
